import React from 'react';
import classNames from 'classnames';
import { RESERVE_STEP_INDEX } from '../../config/constants';
import styles from './index.module.scss';

export default function StepHeader(props) {
  const { current } = props;
  return (
    <div className={styles.stepHeaderWrapper}>
      <div
        className={classNames(styles.stepItem, {
          [styles.current]: current === RESERVE_STEP_INDEX.RESERVE_ITEMS,
          [styles.completed]: current > RESERVE_STEP_INDEX.RESERVE_ITEMS
        })}
      >
        <i
          className={classNames(styles.stepIcon, {})}
        />
        <span>预约项目</span>
      </div>
      <div
        className={classNames(styles.stepItem, {
          [styles.current]: current === RESERVE_STEP_INDEX.TIME_STORE,
          [styles.completed]: current > RESERVE_STEP_INDEX.TIME_STORE
        })}
      >
        <i
          className={classNames(styles.stepIcon, {})}
        />
        <span>门店与时间</span>
      </div>
      <div
        className={classNames(styles.stepItem, {
          [styles.current]: current === RESERVE_STEP_INDEX.CONTACT_INFO,
          [styles.completed]: current > RESERVE_STEP_INDEX.CONTACT_INFO
        })}
      >
        <i
          className={classNames(styles.stepIcon, {})}
        />
        <span>联系信息</span>
      </div>
    </div>
  )
}
